module.exports = __webpack_public_path__ + "static/img/service-row4.cefdaf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/service-row4.png
// module id = e/CD
// module chunks = 1